/**
 * 权限检查指令 allow
 * @param {*} Vue
 */
export default function (Vue) {
  Vue.directive('allow', {
    inserted: (el, binding, vnode) => {
      const { perms } = vnode.context.$route.meta;
      if (perms && !perms.includes(binding.value)) {
        el.parentNode.removeChild(el);
      }
    },
  });
}
